import React, { useCallback } from 'react';

import {
  Box,
  Flex,
  Image,
  Text,
  useTheme,
  useToast as useChakraToast,
  UseToastOptions,
} from '@chakra-ui/react';

import CheckIcon from '@/assets/icons/check-square.svg';
import CloseIcon from '@/assets/icons/crossIcon.svg';

export const useToast = () => {
  const toast = useChakraToast();
  const theme = useTheme();

  return useCallback(
    (
      message: string | React.ReactNode,
      type: 'success' | 'error',
      title?: string | null,
      params?: UseToastOptions,
    ) => {
      toast({
        position: 'top',
        isClosable: false,
        duration: 3000,
        ...params,
        render: ({ onClose, isClosable }) => (
          <Flex
            background={
              type === 'success' ? theme.colors.button.primary.bg : '#E22F2F'
            }
            borderRadius='12px'
            color={type === 'success' ? '#073C1C' : '#fff'}
            fontWeight='bold'
            gap='16px'
            p={'16px'}
            pos='relative'
          >
            {type === 'success' && <Image src={CheckIcon} />}
            <Box>
              {title && (
                <Text fontSize='14px' fontWeight='700'>
                  {title}
                </Text>
              )}
              <Text fontSize='12px'>{message}</Text>
            </Box>
            {isClosable && (
              <Image
                alt=''
                h='12px'
                onClick={onClose}
                pos='absolute'
                right='16px'
                src={CloseIcon}
                top='16px'
                w='12px'
                zIndex='1'
              />
            )}
          </Flex>
        ),
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toast],
  );
};
